import { render, staticRenderFns } from "./AIQnaRevisionProposal.vue?vue&type=template&id=358c0131&scoped=true&"
import script from "./AIQnaRevisionProposal.vue?vue&type=script&lang=js&"
export * from "./AIQnaRevisionProposal.vue?vue&type=script&lang=js&"
import style0 from "./AIQnaRevisionProposal.vue?vue&type=style&index=0&id=358c0131&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c0131",
  null
  
)

export default component.exports